// extracted by mini-css-extract-plugin
export var author = "AuthorInfo-module--author--fAo-L";
export var author__name = "AuthorInfo-module--author__name--wzVZ+";
export var author__position = "AuthorInfo-module--author__position--V76Tq";